import React from 'react';
import { Box } from '@mui/material';

import CheckBox from 'components/common/form-controls/InputFieldV2/CheckBox/CheckBox';
import InstaTaskSideBarItemAutocomplete from './InstaTaskSideBarCustomItems/InstaTaskSideBarItemAutocomplete';
import InstaTaskSideBarItemFiles from './InstaTaskSideBarItemFiles/InstaTaskSideBarItemFiles';

import styles from './instaTaskSideBarItem.styles';
import InstaTaskSideBarItemDateTime from './InstaTaskSideBarCustomItems/InstaTaskSideBarItemDateTime';
import InstaTaskSideBarItemVehicle from './InstaTaskSideBarItemVehicle/InstaTaskSideBarItemVehicle';
import { InstaTaskSideBarItemMultiSelect } from './InstaTaskSideBarCustomItems/InstaTaskSideBarItemMultiSelect';

/*
 * Available options:
 * - text
 * - link
 * - tel
 * - email
 * - autocomplete
 */

const InstaTaskSideBarItem = ({ item }) => {
  if (!item?.value && !item.enableEmpty) return '-';

  switch (item.type) {
    case 'text':
      return <Box sx={styles.defaultStyle}>{item.value}</Box>;
    case 'link':
      return (
        <a href={item.url} target="_blank" rel="noreferrer">
          <Box sx={styles.link}>{item.value}</Box>
        </a>
      );
    case 'tel':
      return (
        <Box sx={styles.itemWrapper}>
          <Box sx={styles.link}>
            <a href={`tel:${item.value}`} target="_blank" rel="noreferrer">
              {item.value}
            </a>
          </Box>
        </Box>
      );
    case 'email':
      return (
        <Box sx={styles.itemWrapper}>
          <Box sx={styles.link}>
            <a href={`mailto:${item.value}`} target="_blank" rel="noreferrer">
              {item.value}
            </a>
          </Box>
        </Box>
      );
    case 'autocomplete':
      return <InstaTaskSideBarItemAutocomplete item={item} />;
    case 'multiselect':
      return <InstaTaskSideBarItemMultiSelect item={item} />;
    case 'dateTime':
      return <InstaTaskSideBarItemDateTime item={item} />;

    case 'files':
      return <InstaTaskSideBarItemFiles {...item} />;
    case 'vehicle':
      return <InstaTaskSideBarItemVehicle {...item} />;
    case 'checkbox': {
      const { value, onChange, disabled, name, id } = item;
      return (
        <CheckBox
          value={value}
          onChange={onChange}
          disabled={disabled}
          name={name}
          id={id}
        />
      );
    }
    default:
      return <Box sx={styles.defaultStyle}>{item?.value}</Box>;
  }
};

export default InstaTaskSideBarItem;
